import { useMemo } from 'react'

import { useTexts } from '../hooks/useTexts'

import { form } from '../formState'

export function Type() {
  const texts = useTexts()

  const options = useMemo(
    () => [
      { value: 'planner', label: texts.labels.roles.planner, type: 'option' as const },
      { value: 'viewer', label: texts.labels.roles.viewer, type: 'option' as const },
      { value: 'guest', label: texts.labels.roles.guest, type: 'option' as const },
      { value: 'courier', label: texts.labels.roles.courier, type: 'option' as const },
    ],
    [texts],
  )

  return <form.SimpleSelect testId="type" name="type" label={texts.labels.role} options={options} />
}
